<div *ngIf="!error" class="container">
  <label class="text status">{{ status }} </label>
</div>
<div class="container" *ngIf="error">
  <p *ngIf="status" class="text error">{{status}}</p>
  <p *ngIf="!status" class="text error">Something went wrong</p>
  <button class="btn error" (click)="onRetry()">Retry</button>
</div>
